var path = 'common/progress-bar/progress-bar.html';
var html = "<div class=\"ns-progress-bar\">\n    <div\n        class=\"progress-bar ns-progress-bar__complete ns-progress-bar__complete--success\"\n        role=\"progressbar\"\n        aria-valuenow=\"\"\n        aria-valuemin=\"0\"\n        aria-valuemax=\"100\"\n        ng-if=\"vm.width\"\n        ng-style=\"{'width': vm.width}\"\n    ></div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/common/progress-bar/progress-bar.html
// module id = 41
// module chunks = 0